import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { IonicModule, ModalController } from "@ionic/angular";

import { SharedModule } from "app/shared/shared.module";
import { IncidentMedicationType } from "app/shared/types";
import { MedicationInputErrorComponent } from "../../../components/medication-input-error/medication-input-error.component";

@Component({
	imports: [SharedModule, IonicModule, MedicationInputErrorComponent],
	templateUrl: "./add-unknown-medication-popup.component.html",
	styleUrls: ["./add-unknown-medication-popup.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddUnknownMedicationPopupComponent {
	private readonly modalCtrl = inject(ModalController);
	private readonly formBuilder = inject(FormBuilder);

	protected readonly form = this.formBuilder.group({
		description: this.formBuilder.control<string>("", [Validators.required, Validators.maxLength(50)]),
		quantity: this.formBuilder.control<number | null>(null, [
			Validators.required,
			Validators.min(0.25),
			Validators.max(99),
		]),
	});

	onConfirm() {
		this.form.markAllAsTouched();

		if (this.form.valid) {
			const { quantity, description } = this.form.value;

			this.modalCtrl.dismiss({
				medication: {
					type: IncidentMedicationType.UNKNOWN,
					description,
				},
				quantity,
			});
			this.form.reset();
		}
	}

	onCancel() {
		return this.modalCtrl.dismiss();
	}
}
